<script setup>
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import { useAuthStore } from './stores/auth.js';
import { useNetworkStore } from './stores/network.js';
import { useCartsStore } from './stores/carts.js';
import { useShiftStore } from './stores/shift.js';
import OfflineOverlay from './components/OfflineOverlay.vue';
import PosFooter from './components/PosFooter.vue';

const auth = useAuthStore();
const network = useNetworkStore();
const carts = useCartsStore();
const shift = useShiftStore();

onMounted(async () => {
  await auth.initDevice();
  // Firestore listeners require the device to be authenticated first.
  carts.init();
  shift.init();
});

// Prevent horizontal swipe-back navigation (browser forward/back on swipe).
function onTouchStart(e) {
  // Prevent swipe-back when touch starts near the left/right edge.
  const x = e.touches[0].clientX;
  const w = window.innerWidth;
  if (x < 20 || x > w - 20) e.preventDefault();
}
</script>

<template>
  <div class="pos-app" @touchstart.passive="onTouchStart">
    <RouterView />
    <PosFooter />
    <OfflineOverlay />
  </div>
</template>

<style scoped>
.pos-app {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}
</style>
